import React from 'react';

export const instagramIcon = () => {
  return (
    <img 
      src="/static/images/instagram.png" 
      alt="Instagram"
      className='w-14 h-14'
      style={{ display: 'inline-block' }}
    />
  );
};
